import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../services/api';
import { Mail, Loader2, ArrowLeft, CheckCircle2 } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email) { setError('Please enter your email'); return; }
    setLoading(true);
    try {
      await auth.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="w-full max-w-md pbb-card p-6 sm:p-8">
        <Link to="/login" data-testid="back-to-login" className="text-xs text-gray-400 hover:text-white inline-flex items-center gap-1 mb-4"><ArrowLeft size={12} /> Back to login</Link>
        <h1 className="text-2xl font-bold">Forgot password?</h1>
        <p className="text-sm text-gray-400 mt-1">Enter your account email — we'll send you a link to reset it. The link is good for 30 minutes.</p>
        {sent ? (
          <div className="mt-6 rounded-xl border border-green-500/30 bg-green-500/10 p-5 text-center">
            <CheckCircle2 className="mx-auto text-green-400" size={26} />
            <div className="mt-3 font-semibold text-green-300">Check your inbox</div>
            <p className="text-sm text-gray-300 mt-1">If <span className="text-white">{email}</span> matches an account, a reset link is on its way.</p>
            <Link to="/login" className="inline-block mt-4 text-sm text-blue-400 hover:text-blue-300 underline">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-wider text-gray-500 font-semibold flex items-center gap-1"><Mail size={12} /> Email</label>
              <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full bg-black border border-[#1f1f1f] rounded-lg px-3 py-2.5 text-sm" placeholder="you@example.com" required />
            </div>
            {error && <div className="text-sm text-red-400">{error}</div>}
            <button data-testid="forgot-submit" type="submit" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg bg-green-600 hover:bg-green-500 text-black font-semibold disabled:opacity-50">
              {loading ? <Loader2 className="animate-spin" size={16} /> : null}
              Send reset link
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
